import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL || '';
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY || '';

// Only create client if both URL and key are available
export const supabase = supabaseUrl && supabaseAnonKey
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
      },
    })
  : null;

// Automatically clear invalid/expired sessions to prevent refresh token errors
if (supabase) {
  supabase.auth.onAuthStateChange((event, session) => {
    if (event === 'TOKEN_REFRESHED' && !session) {
      supabase.auth.signOut();
    }
  });

  // Handle invalid refresh token errors globally
  const originalGetSession = supabase.auth.getSession.bind(supabase.auth);
  supabase.auth.getSession = async () => {
    try {
      const result = await originalGetSession();
      if (result.error && result.error.message?.includes('Refresh Token Not Found')) {
        await supabase.auth.signOut();
        return { data: { session: null }, error: null };
      }
      return result;
    } catch (err: unknown) {
      const error = err as Error;
      if (error?.message?.includes('Refresh Token Not Found')) {
        await supabase.auth.signOut();
        return { data: { session: null }, error: null };
      }
      throw err;
    }
  };
}
